export const FEATURE_FLAG = {
  AI_CONNECTION: "ai_connection",
  ASK_GENIE_CUSTOM_PROMPT: "ask_genie_custom_prompt",
  EXTRACT_STAKEHOLDERS_FROM_PDF: "extract_stakeholders_from_pdf",
  GLOBAL_SEARCH: "global_search",
  INTERNAL_STAKEHOLDER_SOURCE_ID: "internal_stakeholder_source_id",
  ISSUE_HEATMAP: "issue_heatmap",
  NARRATIVE_TRACKER: "narrative_tracker",
  NETWORKS_EXPORT: "networks_export",
  NETWORKS: "networks",
  NEWSLETTER: "newsletter",
  PLAN: "engagement_plan",
  RADAR: "radar",
  STAKEHOLDER_INSIGHT: "stakeholder_insight",
  STAKEHOLDER_PROFILE_CONTACT_DETAILS: "stakeholder_profile_contact_details",
  STAKEHOLDER_PROFILE_EXPORT: "stakeholders_profile_export",
  STAKEHOLDER_PROFILE_WIDGETS: "stakeholder_profile_widgets",
  TARGETED_SENTIMENT: "targeted_sentiment",
  TASK: "engagement_task",
  TOUCHPOINT: "touchpoint",
  DASHBOARDS: "dashboards",
  GEO_CONTEXT_TAB: "geo_context_tab",
  GEO_ASSETS_TAB: "geo_assets_tab",
  CONTENT_SAVED_FILTER_EXTERNAL_EMAIL: "content_saved_filter_external_email",
  CALENDAR_EVENTS_IMPORT_AS_TOUCHPOINTS:
    "calendar_events_import_as_touchpoints",
  TOUCHPOINT_STAKEHOLDERS_ENTITYPICKER_NO_DEFAULT_PROJECT_FILTER:
    "touchpoint_stakeholders_entitypicker_no_default_project_filter",
  ORGANIZATION_POLICY_ACKNOWLEDGMENT: "organization_policy_acknowledgment",
};
